import { customerId as getCustomerId } from './services/LoginService';
import {
    del,
    get,
    patch,
    post,
    put,
} from './Requester';

export function preAppendCustomer(endpoint) {
    let customerId = getCustomerId();
    if (endpoint.startsWith('/')) {
        endpoint = endpoint.substring(1);
    }
    return 'customers/' + customerId + (endpoint !== '' ? '/' : '') + endpoint;
}

export function getCustomerEndpoint(endpoint, opts = {checkAuthorization: true}) {
    return get(preAppendCustomer(endpoint), opts);
}

export function postCustomerEndpoint(endpoint, body = {}, opts = {checkAuthorization: true}) {
    return post(preAppendCustomer(endpoint), body, opts);
}

export function putCustomerEndpoint(endpoint, body = {}, opts = {checkAuthorization: true}) {
    return put(preAppendCustomer(endpoint), body, opts);
}

export function patchCustomerEndpoint(endpoint, body = {}, opts = {checkAuthorization: true}) {
    return patch(preAppendCustomer(endpoint), body, opts);
}

export function deleteCustomerEndpoint(endpoint, body = {}, opts = {checkAuthorization: true}) {
    return del(preAppendCustomer(endpoint), opts);
}

// Feature flags enabled for the current customer, e.g. {"payment-collection": true}.
export function getCustomerFeaturesEndpoint(opts = {checkAuthorization: false}) {
    return getCustomerEndpoint('features', opts);
}

// Collective payments ("Sammelzahlungen", FEAT-149): settings under
// customers/{id}/payment-collection/…, collections under customers/{id}/payment-collections/…
export function paymentCollectionSettingsPath(path = '') {
    return 'payment-collection' + (path ? '/' + path.replace(/^\/+/, '') : '');
}

export function paymentCollectionsPath(path = '') {
    return 'payment-collections' + (path ? '/' + path.replace(/^\/+/, '') : '');
}
